// Base URLs for the Laravel backend. Swap per environment as before.
// export const apiUrl = 'http://127.0.0.1:8000';
export const apiUrl = 'http://139.59.15.241:8003';

// export const imgUrl = 'http://127.0.0.1:8000';
export const imgUrl = 'http://139.59.15.241:8003';

/**
 * Build a tenant-scoped API URL, matching the new routes/api.php:
 *   buildApiUrl('marquis-developers', '/all-projects')
 *   -> 'http://139.59.15.241:8003/api/marquis-developers/all-projects'
 *
 * Prefer apiFetch()/apiJson() from ./api/apiClient for actual requests —
 * they build this same URL AND handle auth headers / JSON parsing. Use
 * buildApiUrl directly only if you need the raw URL string itself (e.g.
 * for an <a href> link to a PDF download endpoint).
 */
export function buildApiUrl(tenant, path) {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiUrl}/api/${tenant}${cleanPath}`;
}